import TokenManagerInterface from "@modules/token_manager/TokenManager/TokenManagerInterface";
import { TokenManagerModule } from "@modules/token_manager/TokenManagerModule";
import { inject, injectable } from "tsyringe";

@injectable()
export class LegacyAdapter {
    private readonly tokenManager: TokenManagerInterface;

    constructor(
        @inject(TokenManagerModule)
        tokenManagerModule: TokenManagerModule
    ) {
        this.tokenManager = tokenManagerModule.exports.tokenManager;

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!(window as any).gw) (window as any).gw = {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (window as any).gw.legacyAdapter = this;
        window.dispatchEvent(new Event("gw:legacyAdapter:ready"));
    }

    public getHashKey() {
        return this.tokenManager.getTokenPayload()?.data.sessionToken;
    }

    public getHESID() {
        return this.tokenManager.getTokenPayload()?.data.sessionToken;
    }

    public runAfterCheck(cb: (...args: any[]) => any) {
        this.tokenManager.isInitialized.subscribe((isInitialized) => {
            if (isInitialized) {
                cb();
            }
        });
    }
}
